module.exports = __webpack_public_path__ + "media/images/emblems/Oberwil_b_bueren-a9060182d2636364d583f4cb4ce04a59.gif";